import { createLogger, LogLevel } from '../../utils/logger';

const logger = createLogger('ModalManager', LogLevel.INFO);

class ModalManager {
  private modalWrapper: HTMLElement | null = null;
  private modalContent: HTMLElement | null = null;

  constructor() {
    logger.info('ModalManager инициализирован');
  }

  openModal(content: HTMLElement | string): void {
    logger.info('Открытие модального окна');
    this.ensureModalElements();
    this.setContent(content);
    
    if (this.modalWrapper) {
      this.modalWrapper.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      this.initCloseEvents();
    }
  }

  closeModal(): void {
    logger.info('Закрытие модального окна');
    if (this.modalWrapper) {
      this.modalWrapper.style.display = 'none';
      document.body.style.overflow = '';
      this.clearContent();
    }
  }

  setContent(content: HTMLElement | string): void {
    if (this.modalContent) {
      if (typeof content === 'string') {
        this.modalContent.innerHTML = content;
      } else {
        // Очищаем содержимое и добавляем элемент
        this.modalContent.innerHTML = '';
        this.modalContent.appendChild(content);
      }
    }
  }

  clearContent(): void {
    if (this.modalContent) {
      this.modalContent.innerHTML = '';
    }
  }

  getModalWrapper(): HTMLElement | null {
    return this.modalWrapper;
  }

  getModalContent(): HTMLElement | null {
    return this.modalContent;
  }

  private ensureModalElements(): void {
    if (!this.modalWrapper) {
      this.modalWrapper = document.getElementById('modal-wrapper');
      if (!this.modalWrapper) {
        // Создаем модальное окно если его нет
        this.modalWrapper = document.createElement('div');
        this.modalWrapper.id = 'modal-wrapper';
        this.modalWrapper.className = 'modal open';
        this.modalWrapper.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: none;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        `;
        document.body.appendChild(this.modalWrapper);
      }
    }

    if (!this.modalContent) {
      this.modalContent = this.modalWrapper.querySelector('.modal__content');
      if (!this.modalContent) {
        this.modalContent = document.createElement('div');
        this.modalContent.className = 'modal__content';
      
        this.modalWrapper.appendChild(this.modalContent);
      }
    }
  }

  private initCloseEvents(): void {
    if (!this.modalWrapper) return;

    const closeHandler = (e: Event) => {
      const target = e.target as HTMLElement;
      
      // Закрытие по клику на overlay
      if (target === this.modalWrapper) {
        this.closeModal();
        return;
      }

      // Закрытие по кнопке закрытия
      if (target.closest('[data-action="close-modal"]') || target.closest('.close__modal')) {
        this.closeModal();
        return;
      }
    };

    // Удаляем предыдущие обработчики
    this.modalWrapper.removeEventListener('click', closeHandler);
    // Добавляем новый обработчик
    this.modalWrapper.addEventListener('click', closeHandler);

    // Закрытие по ESC
    const escHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        this.closeModal();
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
  }
}

// Создаем единственный экземпляр
const modalManager = new ModalManager();

export default modalManager; 